import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import MainComponent from './componentes/pages/main/main.component'

class MuvicardResetPasswordPage extends Component {
	constructor(props) {
		super(props)
	}
	render() {
		return <MainComponent />
	}
}

const connectedMuvicardResetPasswordPage = withRouter(
	connect(null)(MuvicardResetPasswordPage)
)
export { connectedMuvicardResetPasswordPage as ModuleRootComponent }
